<template lang="pug">
include SchoolAdmin.pug
</template>

<script>
import Api from "@/components/services/Api";

export default {
    name: 'SchoolAdmin',
    data() {
        return {
            user: null,
        };
    },
    created() {
        const _this = this;
        Api.me(this.$store.state.token).then(result => {
            // If it is not a professional we must redirect to school
            _this.user = result.data;
        }).catch(err => {
            // TODO: Manage error
        });
    }
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "SchoolAdmin";
</style>



// WEBPACK FOOTER //
// src/components/school_admin/SchoolAdmin.vue